import React from 'react';

interface State { hasError: boolean; error?: Error; }

/**
 * Global error boundary — a render crash anywhere in the dashboard shows a
 * recoverable card instead of a blank white screen. The bots + trading backend
 * keep running regardless; this guards only the UI.
 */
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[MAMTA AI] UI crash caught by ErrorBoundary:', error, info?.componentStack);
    try {   // KALI Phase 3 P3-H6: the crash reaches the server notebook too
      (window as any).__jcReportUiCrash?.('boundary', error?.message || String(error), (error?.stack || '') + (info?.componentStack || ''));
    } catch { /* never throw from the boundary */ }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#0a0e1a', color: '#e2e8f0', fontFamily: 'system-ui', padding: 24 }}>
        <div style={{ maxWidth: 520, textAlign: 'center', background: '#0f172a',
          border: '1px solid #1e293b', borderRadius: 16, padding: 32 }}>
          <div style={{ fontSize: 46, marginBottom: 12 }}>⚠️</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#f87171', marginBottom: 8 }}>
            Dashboard hit an error
          </div>
          <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 18, lineHeight: 1.7 }}>
            Ek UI component crash hua — aapke bots aur trading backend chalte rahenge, ye sirf screen hai.
            {this.state.error?.message
              ? <><br /><span style={{ color: '#64748b' }}>{this.state.error.message}</span></>
              : null}
          </div>
          <button onClick={() => { this.setState({ hasError: false, error: undefined }); (window as any).__jcMarkUserReload?.(); location.reload(); }}
            style={{ background: 'linear-gradient(135deg,#4f46e5,#6366f1)', color: '#fff', border: 'none',
              borderRadius: 10, padding: '10px 22px', fontSize: 13, fontWeight: 800, cursor: 'pointer' }}>
            🔄 Reload Dashboard
          </button>
        </div>
      </div>
    );
  }
}
